import cpp from './svgs/cpp.svg';
import python from './svgs/python.svg';
import java from './svgs/java.svg';
import css from './svgs/css.svg';
import html from './svgs/html.svg';
import javascript from './svgs/javascript.svg';
import typescript from './svgs/typescript.svg';
import dart from './svgs/dart.svg';
import kotlin from './svgs/kotlin.svg';
import react from './svgs/react.svg';
import vue from './svgs/vue.svg';
import django from './svgs/django.svg';
import qt from './svgs/qt.svg';
import spring from './svgs/spring.svg';
import flutter from './svgs/flutter.svg';
import pytorch from './svgs/pytorch.svg';
import mysql from './svgs/mysql.svg';
import postgresql from './svgs/postgresql.svg';
import sqlite from './svgs/sqlite.svg';
import redis from './svgs/redis.svg';
import azure from './svgs/azure.svg';
import git from './svgs/git.svg';
import docker from './svgs/docker.svg';
import kubernetes from './svgs/kubernetes.svg';
import nextjs from './svgs/nextjs.svg';
import flask from './svgs/flask.svg';
import nodejs from './svgs/nodejs.svg';
import gcp from './svgs/gcp.svg';
import supabase from './svgs/supabase.svg';
import stripe from './svgs/stripe.svg';
import vercel from './svgs/vercel.svg';
import huggingface from './svgs/huggingface.svg';
import sklearn from './svgs/sklearn.svg';
import auth0 from './svgs/auth0.svg';
import linux from './svgs/linux.svg';
import openshift from './svgs/openshift.svg';
import maven from './svgs/maven.svg';
import cmake from './svgs/cmake.svg';

const skillsData = {
  Languages: [
    { name: 'Python', icon: python },
    { name: 'Java', icon: java },
    { name: 'C++', icon: cpp },
    { name: 'JavaScript', icon: javascript },
    { name: 'TypeScript', icon: typescript },
    { name: 'Kotlin', icon: kotlin },
    { name: 'Dart', icon: dart },
    { name: 'HTML', icon: html },
    { name: 'CSS', icon: css },
  ],
  'Machine Learning & NLP': [
    { name: 'PyTorch', icon: pytorch },
    { name: 'Hugging Face', icon: huggingface },
    { name: 'scikit-learn', icon: sklearn },
  ],
  'Web & Frameworks': [
    { name: 'React.js', icon: react },
    { name: 'Next.js', icon: nextjs },
    { name: 'Vue.js', icon: vue },
    { name: 'Django', icon: django },
    { name: 'Flask', icon: flask },
    { name: 'Spring Boot', icon: spring },
    { name: 'Node.js', icon: nodejs },
    { name: 'Flutter', icon: flutter },
    { name: 'Qt', icon: qt },
  ],
  'Cloud & DevOps': [
    { name: 'Google Cloud', icon: gcp },
    { name: 'Azure', icon: azure },
    { name: 'Docker', icon: docker },
    { name: 'Kubernetes', icon: kubernetes },
    { name: 'OpenShift', icon: openshift },
    { name: 'Auth0', icon: auth0 },
    { name: 'Vercel', icon: vercel },
    { name: 'Linux', icon: linux },
  ],
  'Data & Tools': [
    { name: 'PostgreSQL', icon: postgresql },
    { name: 'MySQL', icon: mysql },
    { name: 'Redis', icon: redis },
    { name: 'SQLite', icon: sqlite },
    { name: 'Supabase', icon: supabase },
    { name: 'Stripe', icon: stripe },
    { name: 'Git', icon: git },
    { name: 'Maven', icon: maven },
    { name: 'CMake', icon: cmake },
  ],
};

export default skillsData;
